module.exports = __webpack_public_path__ + "img/goldregen-2020-059.e87fdb23.jpg";